import FuzzySearch from "fuzzy-search";
import Guides from "Guides";
import useSearchQuery from "Hooks/useSearchQuery";
import { useMemo } from "react";
import Content from "Types/Content";

const useGuidesSugestions = (): Content[] => {
  const query = useSearchQuery();
  const search = useMemo(() => query.get("query"), [query]);
  const fuzzySearcher = useMemo(
    () =>
      new FuzzySearch(Guides, ["title", "route", "tags"], {
        caseSensitive: false,
        sort: true
      }),
    []
  );
  return useMemo(
    () => (search ? fuzzySearcher.search(search) : []),
    [search, fuzzySearcher]
  );
};

export default useGuidesSugestions;
